<template>
  <div v-if="delegate" class="sidebar_content">
    <div class="profile_section">
      <img
        :src="delegate.avatar || defaultAvatar"
        alt="avatar"
        class="profile_avatar"
      />
      <h3 class="profile_name" @click="$emit('open-delegate', delegate.id)">
        {{ delegate.name }}
      </h3>
      <span
        class="profile_badge"
        :class="{ active: delegate.is_active, inactive: !delegate.is_active }"
      >
        {{ delegate.is_active ? $t("STATUS.active") : $t("STATUS.inactive") }}
      </span>
    </div>

    <div class="info_section">
      <div class="info_item">
        <i class="fas fa-phone"></i>
        <span class="info_label">{{ $t("PLACEHOLDERS.mobile") }}</span>
        <span class="info_value">{{ delegate.mobile }}</span>
      </div>

      <div class="info_item">
        <i class="fas fa-map-marker-alt"></i>
        <span class="info_label">{{ $t("PLACEHOLDERS.current_location") }}</span>
        <span class="info_value">{{ delegate.lat }}, {{ delegate.lng }}</span>
      </div>

      <div class="info_item" v-if="delegate.last_login_at">
        <i class="fas fa-clock"></i>
        <span class="info_label">{{ $t("PLACEHOLDERS.last_login") }}</span>
        <span class="info_value">{{ delegate.last_login_at }}</span>
      </div>
    </div>

    <div class="action_buttons">
      <button
        v-if="!isTracking"
        class="action_btn primary"
        @click="$emit('track', delegate)"
      >
        <i class="fas fa-location-arrow"></i>
        {{ $t("BUTTONS.track_live") }}
      </button>
      <button
        v-if="delegate.bundle_id"
        class="action_btn danger"
        @click="$emit('open-bundle', delegate.bundle_id)"
      >
        <i class="fas fa-info-circle"></i>
        {{ $t("BUTTONS.bundle_details") }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "DelegateDetailsPanel",

  props: {
    delegate: {
      type: Object,
      default: null,
    },
    defaultAvatar: {
      type: String,
      required: true,
    },
    isTracking: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
